// removed by extract-text-webpack-plugin
module.exports = {"border":"src-components-commons-BorderTop-style----general-module---border---lNmE- borderColor-smoke borderStyle-solid borderTopWidth-1 borderWidth-0 breakPointM-borderTopWidth-0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/commons/BorderTop/style/general.module.css
// module id = 1423
// module chunks = 168707334958949